import { render, staticRenderFns } from "./yearOnly.vue?vue&type=template&id=2403c838"
import script from "./yearOnly.vue?vue&type=script&lang=js"
export * from "./yearOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports